var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7334 13.8667C15.7334 14.6399 16.3602 15.2667 17.1334 15.2667C17.9066 15.2667 18.5334 14.6399 18.5334 13.8667C18.5334 13.0935 17.9066 12.4667 17.1334 12.4667C16.3602 12.4667 15.7334 13.0935 15.7334 13.8667Z",
  stroke: "#333333",
  strokeWidth: 1.5
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1334 7.33333H15.7334C18.3732 7.33333 19.6932 7.33333 20.5133 8.15343C21.3334 8.97354 21.3334 10.2935 21.3334 12.9333V14.8C21.3334 17.4399 21.3334 18.7598 20.5133 19.5799C19.6932 20.4 18.3732 20.4 15.7334 20.4H10.1334C6.61353 20.4 4.85362 20.4 3.76016 19.3065C2.66669 18.2131 2.66669 16.4532 2.66669 12.9333V11.0667C2.66669 7.54685 2.66669 5.78694 3.76016 4.69347C4.85362 3.6 6.61353 3.6 10.1334 3.6H13.8667C14.7347 3.6 15.1686 3.6 15.5247 3.69541C16.491 3.95432 17.2457 4.70905 17.5046 5.67531C17.6 6.03137 17.6 6.46536 17.6 7.33333",
  stroke: "#333333",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
function SvgMomoOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomoOrder);
export default __webpack_public_path__ + "static/media/momoOrder.b6271d06.svg";
export { ForwardRef as ReactComponent };